module.exports = __webpack_public_path__ + "img/locked.a53d560a.svg";